module.exports = __webpack_public_path__ + "img/soundcloud.f3006c1d.png";